(() => {
  if (!document.body.classList.contains("cb-ho-migration")) return;
  if (!document.body.classList.contains("template-product")) return;

  const dedupeEasySellButtons = () => {
    const containers = document.querySelectorAll(".product-form-buttons, #es-form-hook");
    containers.forEach((container) => {
      const buttons = container.querySelectorAll(".es-popup-button, .es-popup-button-product");
      buttons.forEach((button, index) => {
        if (index === 0) return;
        button.remove();
      });
    });
  };

  const applyEasySellCtaMatch = () => {
    dedupeEasySellButtons();
    const buttons = document.querySelectorAll(
      ".product-form-buttons .es-popup-button-product, .product-form-buttons .es-popup-button, #es-form-hook .es-popup-button-product, #es-form-hook .es-popup-button"
    );
    buttons.forEach((button) => {
      const styles = {
        display: "flex",
        "align-items": "center",
        "justify-content": "center",
        width: "100%",
        height: "52px",
        "min-height": "52px",
        margin: "0",
        padding: "0 18px",
        border: "1px solid #000",
        "border-radius": "0",
        "box-shadow": "none",
        background: "#fff",
        "background-image": "none",
        color: "#000",
        "font-size": "12px",
        "font-weight": "700",
        "font-style": "normal",
        "line-height": "1",
        "letter-spacing": "0.04em",
        "text-transform": "uppercase",
      };
      Object.entries(styles).forEach(([property, value]) => {
        button.style.setProperty(property, value, "important");
      });
      button.querySelectorAll(".es-button-title, span, div").forEach((node) => {
        node.style.setProperty("font-size", "12px", "important");
        node.style.setProperty("font-weight", "700", "important");
        node.style.setProperty("line-height", "1", "important");
        node.style.setProperty("color", "inherit", "important");
        node.style.setProperty("text-transform", "uppercase", "important");
      });
    });
  };

  let scheduled = false;
  const scheduleMatch = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      applyEasySellCtaMatch();
    });
  };

  applyEasySellCtaMatch();
  const root = document.querySelector("main") || document.body;
  const observer = new MutationObserver(scheduleMatch);
  observer.observe(root, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ["style", "class"],
  });
  [100, 300, 800, 1600, 3200].forEach((ms) => window.setTimeout(applyEasySellCtaMatch, ms));
})();
